import { TILE_LIBRARY_TYPES } from '../../../state/map/tiles/constants';
import LeafletContextMenu from './LeafletContextMenu';
import HereContextMenu from './HereContextMenu';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [TILE_LIBRARY_TYPES.LEAFLET]: LeafletContextMenu,
  [TILE_LIBRARY_TYPES.JSLA]: HereContextMenu,
};
